<template>
  <div class="">
    <div
      class="d-flex align-items-center title-background ps-2 py-1 mouse-hover"
      @click="togleDisplay(parentRuleReference + rulePropertyEnum)"
    >
      <div class="ps-1" />
      <ruleCaret
        v-model="displayDetails"
      />
      <div class="fw-bold ps-1 flex-grow-1">
        {{ title }}
      </div>
      <div
        v-if="displayDelete"
        class="fw-bold px-3 me-3 mouse-hover"
        @click="removeRuleProperty(ruleRroperty.else)"
      >
        X
      </div>
    </div>
    <div class="ms-4 py-1 my-2 condition-border">
      <div
        v-if="displayDetails"
        class="fw-bold my-1 ms-3"
      >
        {{ trans(`subscription.validation_rules.rule_type`) }}
      </div>
      <div v-if="displayDetails">
        <RuleSelect
          v-model="model"
          class="mx-3"
        />
      </div>
      <RuleTypeShow
        :rule="rule"
        :display-delete="false"
      />
    </div>
  </div>
</template>

<script>
import { RULE_PROPERTY } from '@/constants'
import ruleMixin from '@/employees/components/Rule/utilities/mixins/ruleMixin'
import { mapState } from 'vuex'
export default {
  name: 'RuleIfElseCondition',
  mixins: [ruleMixin],
  props: {
    parentRuleReference: {
      required: true,
      type: String,
    },
    rule: {
      required: true,
      type: Object,
    },
    title: {
      required: true,
      type: String,
    },
    value: {
      required: true,
      type: String,
    },
    displayDelete: {
      required: false,
      type: Boolean,
      default: false,
    },
    rulePropertyEnum: {
      required: true,
      type: String,
    },
  },
  data () {
    return {
      ruleRroperty: RULE_PROPERTY,
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (newValue) {
        this.applyRuleTypeChange(newValue)
        this.$emit('input', newValue)
      },
    },
    ...mapState({
      displayDetails (state) {
        return state.rules.displayRuleMap[this.parentRuleReference + this.rulePropertyEnum]
      },
    }),
  },
  methods: {
    applyRuleTypeChange (ruleEnum) {
      if (this.rule.reference) {
        this.searchParentAddChild(this.rule.reference, ruleEnum, 'if')
        this.hideDisplay(this.parentRuleReference + this.rulePropertyEnum)
      }
    },
    removeRuleProperty (rulePropertyEnum) {
      if (this.displayDetails) {
        this.togleDisplay(this.parentRuleReference + this.rulePropertyEnum)
      }
      this.rulePropertyValueDelete(this.parentRuleReference, rulePropertyEnum)
    },
  },
}
</script>

<style lang="scss" scoped>
.title-background {
  background-color: rgba(0, 0, 0, 0.2);
}
.condition-border {
  border-left-style: dotted;
  border-color: gray;
  border-width: 2px;
}
.mouse-hover {
  cursor: pointer
}
</style>
